import { render } from "./WiseLoginModal.vue?vue&type=template&id=3aead780"
import script from "./WiseLoginModal.vue?vue&type=script&lang=js"
export * from "./WiseLoginModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__